<template>
  <v-dialog v-model="value" :scrollable="scrollable" persistent :max-width="maxWidth">
    <v-card :max-width="maxWidth">
      <v-card-title class="ml-2 subheading">{{title}}</v-card-title>
      <v-card-text class="py-2 body-1">
        <v-flex v-if="text.length" layout justify-center row>
          <div style="word-wrap: break-word; word-break: break-all">{{text}}</div>
          <!--<span>{{beforeItem}}</span>-->
          <!--<span class="body-2 primary&#45;&#45;text px-1">-->
          <!--{{itemText}}-->
          <!--</span>-->
          <!--<span>{{afterItem}}</span>-->
          <!--<span>？</span>-->
        </v-flex>
        <v-flex layout justify-center row>
          <!--<v-container>-->
          <slot></slot>
          <!--</v-container>-->
        </v-flex>
      </v-card-text>
      <v-divider v-if="scrollable"></v-divider>
      <v-card-text class="py-0" :style="{'maxHeight': scrollHeight, 'overflowY': 'auto'}">
        <slot name="scroll"></slot>
      </v-card-text>
      <v-divider v-if="scrollable"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!disableCancel"
          :loading="cancelLoading"
          @click.native="cancel"
          color="grey"
          flat
        >
          {{disableText}}
        </v-btn>
        <v-btn
          v-if="!disableConfirm"
          :loading="confirmLoading"
          @click.native="save"
          flat
          color="primary"
        >
          {{confirmText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirmOperationDialog',
  props: {
    scrollable: {
      type: Boolean,
      default: false,
    },
    scrollHeight: {
      type: String,
      default: '100px'
    },
    maxWidth: {
      type: String,
      default: '300px'
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '确认操作'
    },
    text: {
      type: String,
      default: ''
    },
    operation: {
      type: String,
      default: ''
    },
    itemText: {
      type: String,
      default: ''
    },
    afterItem: {
      type: String,
      default: ''
    },
    disableConfirm: {
      type: Boolean,
      default: false,
    },
    disableCancel: {
      type: Boolean,
      default: false,
    },
    disableText: {
      type: String,
      default: '取消',
    },
    confirmText: {
      type: String,
      default: '确定',
    },
  },
  data: () => ({
    activate: false,
    cancelLoading: false,
    confirmLoading: false,
  }),
  watch: {
    value () {
      // this.activate = this.value
      // console.log('change', this.activate)
      if (this.value === false) {
        this.cancelLoading = false
        this.confirmLoading = false
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
      this.cancelLoading = true
      if (this.autoClose) {
        this.$emit('input', false)
      }
    },
    save () {
      this.$emit('confirm')
      this.confirmLoading = true
      if (this.autoClose) {
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style scoped>

</style>
